import type { CompanyQuota, Quota } from 'domain/quota';

import { CompanyTabName } from '../../../domain/page';
import { translate } from '../../../services/i18n';
import { formatCompactNumber } from '../../../services/numberFormat';
import { QuotaLeftText } from '../../quota-components/QuotaLeftText';

import { StyledCredits, StyledCreditsButton, StyledCreditsValue } from './styles';

type Props = {
  isDataCreditsEnabled: boolean;
  quota: Quota | CompanyQuota;
  location: CompanyTabName;
  onClick?: VoidFunction;
};

export const QuotaButton = ({ isDataCreditsEnabled, quota, location, onClick }: Props) => {
  const shouldShowDataCredits = isDataCreditsEnabled && location !== CompanyTabName.Insights;

  const getFormattedCreditsInfo = (): string | number => {
    if (location === CompanyTabName.Overview) {
      return `${Math.max(0, quota.used)}/${formatCompactNumber(Math.max(0, quota.total))}`;
    }

    return formatCompactNumber(Math.max(0, quota.remaining));
  };

  const getLabel = () => {
    switch (location) {
      case CompanyTabName.Overview:
        return translate(`header.credits.overview.${(quota as CompanyQuota)?.interval}`);

      case CompanyTabName.Insights:
        return translate('header.credits.insights');

      case CompanyTabName.Contacts:
        return translate('header.credits.contacts');

      default:
        return '';
    }
  };

  if (shouldShowDataCredits) {
    return (
      <StyledCreditsButton variant="flat" onClick={onClick}>
        <QuotaLeftText quota={quota} />
      </StyledCreditsButton>
    );
  }

  return (
    <StyledCreditsButton variant="flat" onClick={onClick}>
      <StyledCredits data-automation="Credits">{getLabel()}</StyledCredits>
      <StyledCreditsValue data-automation="CreditsValue">{getFormattedCreditsInfo()}</StyledCreditsValue>
    </StyledCreditsButton>
  );
};
